export default __webpack_public_path__ + "static/media/1014.1231d1ba.png";